export default __webpack_public_path__ + "static/dla-biznesu-afc1ff8fa3e3d81c6f158ad7033f1381.svg";